<!-- Button -->
<button
    mat-icon-button
    [matTooltip]="tooltip || ('fullscreen.tooltip' | transloco)"
    (click)="toggleFullscreen()"
>
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>


<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon class="mat-icon-white" [svgIcon]="'heroicons_outline:arrows-pointing-out'"></mat-icon>
</ng-template>